import { useClassified } from "@/contexts/classified";
import { useI18n } from "@/shared/hooks";
export const useMortgage = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { t } = useI18n();
    const mortgage = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.sections) === null || _b === void 0 ? void 0 : _b.mortgage;
    if (!mortgage)
        return null;
    const { showMonthlyRateLabel, showRentLabel, monthlyAmount, region } = mortgage;
    let priceLinkLabel = "";
    if (showMonthlyRateLabel) {
        priceLinkLabel = monthlyAmount
            ? `${t("hardfacts.price.monthly_rate_new", {
                replace: {
                    value: Math.round(parseFloat(monthlyAmount)),
                },
            })}`
            : t("hardfacts.price.financial_link");
    }
    else if (showRentLabel) {
        priceLinkLabel = t("hardfacts.price.rent_label");
    }
    return {
        id: (_c = mortgage.id) !== null && _c !== void 0 ? _c : "",
        federalStateGeoId: (_d = mortgage.federalStateGeoId) !== null && _d !== void 0 ? _d : "",
        price: (_e = mortgage.price) !== null && _e !== void 0 ? _e : 0,
        prov: (_f = mortgage.prov) !== null && _f !== void 0 ? _f : 0,
        zip: (_g = mortgage.zip) !== null && _g !== void 0 ? _g : "",
        city: (_h = mortgage.city) !== null && _h !== void 0 ? _h : "",
        country: (_j = mortgage.country) !== null && _j !== void 0 ? _j : "",
        region,
        subType: (_k = mortgage.subType) !== null && _k !== void 0 ? _k : "",
        showMonthlyRateLabel: (_l = mortgage.showMonthlyRateLabel) !== null && _l !== void 0 ? _l : false,
        showRentLabel: (_m = mortgage.showRentLabel) !== null && _m !== void 0 ? _m : false,
        monthlyAmount: (_o = mortgage.monthlyAmount) !== null && _o !== void 0 ? _o : null,
        originvariant: "WL_CDP",
        priceLinkLabel,
    };
};
